import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase"; // Import your firebase auth instance
import clientData from "../../utils/clientData.json";
import "./ClientLoginPage.css";
import usePageMeta from "../../hooks/usePageMeta";

function ClientLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  usePageMeta(
    "Client Login | TjWit Media",
    "Login to the secure client portal to view your private photo albums."
  );

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Find the client in our JSON data to get their ID
        const client = clientData.find(
          (c) => c.clientEmail.toLowerCase() === email.toLowerCase()
        );
        if (client) {
          // Redirect to their personal dashboard
          navigate(`/client/${client.clientID}`);
        } else {
          setError("Client data not found.");
        }
      })
      .catch((err) => {
        // Handle Firebase errors (wrong password, user not found, etc.)
        setError("Invalid email or password. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h1>Client Portal Login</h1>
        <div className="input-group">
          <input
            type="email"
            placeholder="Email"
            className="input-field"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <input
            type="password"
            placeholder="Password"
            className="input-field"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="login-button" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
        <p className="error-message">{error}</p>
      </form>
    </div>
  );
}

export default ClientLoginPage;
